import { render } from "./SocialMediaLinks.vue?vue&type=template&id=63f4f479&scoped=true"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=js"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=js"

import "./SocialMediaLinks.vue?vue&type=style&index=0&id=63f4f479&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f4f479"]])

export default __exports__